import Entity from '../entity'

export default class ArticleCategory extends Entity<number>{
    name:string = "";
    showOnHome:boolean = false;
    showInMainMenu:boolean = false;
    order:number=0;
}